export var slice = Array.prototype.slice;



//////////////////
// WEBPACK FOOTER
// /Users/alextaxiera/source/farmhand-server/client/dashboard/~/d3-shape/src/array.js
// module id = ../../../dashboard/node_modules/d3-shape/src/array.js
// module chunks = 1